import { Component, inject, TemplateRef, ViewChild } from '@angular/core';
import { TimesheetFilterComponent } from '../timesheet-filter/timesheet-filter.component';
import { CommonModule } from '@angular/common';
import { ListTableComponent } from '../../../../shared/components/list-table/list-table.component';
import { NgZorroModule } from '../../../../shared/modules/ng-zorro/ng-zorro.module';
import { TableRowActions } from '../../../../shared/interfaces/actions';
import { TableRowActionsModel } from '../../../../shared/interfaces/list.interface';
import { LookupService } from '../../../../services/lookup.service';
import { ListService } from '../../../../shared/services/list.service';
import { DateTimeFormatterService } from '../../../../shared/utils/date-time-formatter.service';
import { TimesheetStaffErrorcodeComponent } from "../timesheet-staff-errorcode/timesheet-staff-errorcode.component";
import { DialogConfig, DialogService } from '../../../../shared/services/dialog.service';
import { PopupDialogComponent } from '../../../../shared/components/popup-dialog/popup-dialog.component';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { TimesheetService } from '../../../../services/timesheet.service';
import { ENDPOINTS } from '../../../../shared/constants/url.constants';
import { ErrorAlertService } from '../../../../shared/services/error-alert.service';
import { NzFormDirective } from 'ng-zorro-antd/form';
import { SharedDataService } from '../../../../shared/services/shared-data-service';
import { UserService } from '../../../../services/user.service';

@Component({
  selector: 'ppl-timesheet-pended-list',
  standalone: true,
  imports: [ListTableComponent,
    NgZorroModule,
    CommonModule,
    TimesheetFilterComponent,
    TimesheetStaffErrorcodeComponent,
    PopupDialogComponent,
    FormsModule,
    NzFormDirective,
    ReactiveFormsModule
  ],
  templateUrl: './timesheet-pended-list.component.html',
  styleUrl: './timesheet-pended-list.component.css'
})
export class TimesheetPendedListComponent {
  @ViewChild(ListTableComponent) childComponent!: ListTableComponent;
  @ViewChild(TimesheetFilterComponent) timesheetFilterChildComponent!: TimesheetFilterComponent;
  @ViewChild('pendedDialog') pendedDialog!: TemplateRef<any>;
  @ViewChild('confirmationDialog') confirmationDialog!: TemplateRef<any>;
  @ViewChild('warningDialog') warningDialog!: TemplateRef<any>;

  private dialogSvc = inject(DialogService);

  actionButtons: TableRowActionsModel = new TableRowActions({ view: false });
  appliedFilters: any;
  programName!: string;
  processingStatusList: any;
  reasonList: any;
  businessStatusList: any;
  timesheets: any[] = [];
  pendedDialogId: any;
  errorcodeData: any;
  title: string = '';
  okText: string = '';
  placeholder: string = '';
  showActionPopup: boolean = false;
  buttonActionEvent: any;
  selectedCheckboxes: any;
  processCodes: any[] = [];
  pendCodes: any[] = [];
  allowedProcessCodes: any[] = [];
  totalTimesheetsEffected = 0;
  timesheetActionForm!: FormGroup;

  cols = [
    {
      field: 'payPeriod',
      header: 'Pay Period',
      jsonpath: 'payPeriod',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'serviceDate',
      header: 'Service Date',
      jsonpath: 'serviceDate',
      isDisplayedAtHeader: 'y',
      isSearchable: 'y',
    },
    {
      field: 'createdDate',
      header: 'Submission Date',
      jsonpath: 'createdDate',
      isDisplayedAtHeader: 'y',
      isSearchable: 'y',
    },
    {
      field: 'consumerName',
      header: 'Consumer Name',
      jsonpath: 'consumerName',
      isDisplayedAtHeader: 'y',
      isSearchable: 'y',
    },
    {
      field: 'consumerPPLId',
      header: 'Consumer PPL ID',
      jsonpath: 'consumerPPLId',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'providerPPLId',
      header: 'PA PPL ID',
      jsonpath: 'providerPPLId',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'applicationStatus',
      header: 'Application Status',
      jsonpath: 'applicationStatus',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'processStatus',
      header: 'Processing Status',
      jsonpath: 'processStatus',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'serviceDesc',
      header: 'Service Description',
      jsonpath: 'serviceDesc',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'timeInTimeOut',
      header: 'Time In - Time Out',
      jsonpath: 'timeInTimeOut',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'billedUnit',
      header: 'Billed Units (15 Mins Increment)',
      jsonpath: 'billedUnit',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'billedUnitInHours',
      header: 'Billed Units (hrs)',
      jsonpath: 'billedUnitInHours',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'billRate',
      header: 'Service Rate',
      jsonpath: 'billRate',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    }
  ];

  buttons = [
    {
      button_id: "Override",
      button_label: "Override",
      buttonAction: "overrideTimesheet",
      className: "primary-btn-color"
    },
    {
      button_id: "OverrideAll",
      button_label: "Override All",
      buttonAction: "overrideAllTimesheets",
      className: "primary-btn-color"
    },
    {
      button_id: "Deny",
      button_label: "Deny",
      buttonAction: "denyTimesheet",
      className: "primary-btn-color"
    },
    {
      button_id: "DenyAll",
      button_label: "Deny All",
      buttonAction: "denyAllTimesheet",
      className: "primary-btn-color"
    },
    {
      button_id: "submitForProcessing",
      button_label: "Submit For Processing",
      buttonAction: "submitForProcessing",
      className: "primary-btn-color"
    },
  ]

  fields = [
    { field: 'Timeframe', show: true, default: '30 days' },
    { field: 'consumer', show: true },
    { field: 'consumerPplId', show: true },
    { field: 'provider', show: true },
    { field: 'providerPplId', show: true },
    { field: 'payPeriod', show: true },
    { field: 'paymentDate', show: true },
    { field: 'processStatusLkup', show: true, default: 'PE' },
    { field: 'serviceCode', show: true },
    { field: 'processCode', show: true },
    { field: 'serviceDate', show: true },
  ];

  keyMapping: { [key: string]: string } = {
    Timeframe: "serviceDuration",
    payPeriod: "serviceId",
    consumer: "consumerName",
    provider: "providerName",
    providerPplId: "providerPPLId",
    consumerPplId: "consumerPPLId",
    processStatusLkup: "processStatus",
    paymentDate: "paymentId"
  };

  constructor(
    private listService: ListService,
    private fb: FormBuilder,
    private lookupService: LookupService,
    private dateTimeFormatterService: DateTimeFormatterService,
    private timesheetService: TimesheetService,
    private errorAlertService: ErrorAlertService,
    private sharedDataService: SharedDataService,
    private userService: UserService
  ) { }

  ngOnInit(): void {
    this.timesheetActionForm = this.fb.group({
      selectedProcessCode: [null, [Validators.required]],
      reason: [null, [Validators.required]],
      comments: [null, [Validators.required, Validators.maxLength(10000)]],
    });

    const selectedProgram = this.userService.getSelectedProgram();
    this.programName = selectedProgram?.program_code ?? '';
    this.businessStatusList = this.lookupService.getLookupValue('Business Status');
    this.processingStatusList = this.lookupService.getLookupValue('TS_App_S');
    this.reasonList = this.lookupService.getLookupValue('Disposition Reason');
    this.getProcessCodes();
  }

  loadRecordsAfterUpdate() {
    let filters = this.appliedFilters;
    if (!this.appliedFilters || this.appliedFilters.length == 0) {
      filters = [];
      filters.push({
        jsonPath: "serviceDuration",
        value: '30 days',
        operator: "lessThan"
      }, {
        jsonPath: "processStatus",
        value: 'PE',
        operator: "Equal"
      });
    }

    this.searchTimesheets(filters);
  }

  getProcessCodes() {
    this.timesheetService
      .getProcessCodes(this.programName)
      .subscribe((data: any) => {
        this.processCodes = this.sharedDataService.sortByKey(data.responsedata, 'code');
        this.processCodes.map((processCode: any) => {
          processCode.displayName = `${processCode.code.trim()} - ${processCode.desc.trim()}`;
        });
      });
  }

  buildRequestPayload(pageName: string, orderBy: string, searchParams: [], startingPageNumber = 1) {
    if (searchParams.length == 0) {
      //handle the error here
      return;
    }

    const payload: any = {
      pageName: pageName,
      programCode: this.programName,
      condition: 'and',
      recordsPerPage: 20,
      startingPageNumber: startingPageNumber,
      searchParam: searchParams,
      orderByColumn: orderBy ? [orderBy] : [],
      orderBy: ['desc'],
    };
    return payload;
  }

  searchTimesheets(filters: any, startingPageNumber = 1, currentPage = 0) {
    if (startingPageNumber == 1) {
      this.timesheets = [];
    }

    const processedPayload = this.buildRequestPayload(
      'pendManagementList',
      'timesheetLineId',
      filters,
      startingPageNumber
    );

    this.listService
      .getListData(processedPayload, 'claims')
      .subscribe((data: any) => {
        const records = this.processData(data.responsedata);
        if (startingPageNumber > 1) {
          this.timesheets = [...this.timesheets, ...records];
        } else {
          this.timesheets = records;
        }

        if (this.childComponent) {
          this.childComponent.resetPagination(startingPageNumber, currentPage);
        }
      });
  }

  processData(data: any) {
    if (data && data.length > 0) {
      data.forEach((element: any) => {
        element.payPeriod = element.payrollStart + ' - ' + element.payrollEnd,
          element.timeInTimeOut = this.dateTimeFormatterService.convertTo12HourFormat(element.timeIn) + ' - ' + this.dateTimeFormatterService.convertTo12HourFormat(element.timeOut),
          element.applicationStatus = this.businessStatusList.filter((status: any) => status.lkpValueCode === element.businessStatus)
            .map((status: any) => status.lkpValueName),
          element.processingStatusLkp = element.processStatus,
          element.processStatus = this.processingStatusList.filter((status: any) => status.lkpValueCode === element.processStatus)
            .map((status: any) => status.lkpValueName),
          element.billedUnitInHours = (element.billedUnit * 15) / 60,
          element.billRate = element.billRate ? element.billRate : null
      });

      return data;
    }

    return data;
  }

  onPageLoad(event: any) {
    this.searchTimesheets(this.appliedFilters, event.startingPageNumber, event?.first ?? 0);
  }

  onSearch(event: any) {
    const filters = [];
    filters.push({
      jsonPath: "serviceDuration",
      value: event.Timeframe ? event.Timeframe : '30 days',
      operator: "lessThan"
    });

    if (event.serviceDate) {
      filters.push({
        jsonPath: "serviceDate",
        value: this.dateTimeFormatterService.formatDateToString(event.serviceDate as Date),
        operator: "Equal"
      });
    }

    if (event.payPeriod) {
      filters.push({
        jsonPath: "serviceId",
        value: event.payPeriod,
        operator: "Equal"
      });
    }

    if (event.consumer && event.consumer.trim()) {
      filters.push({
        jsonPath: "consumerName",
        value: event.consumer.trim(),
        operator: "Contains"
      });
    }

    if (event.provider && event.provider.trim()) {
      filters.push({
        jsonPath: "providerName",
        value: event.provider.trim(),
        operator: "Contains"
      });
    }

    if (event.providerPplId && event.providerPplId.trim()) {
      filters.push({
        jsonPath: "providerPPLId",
        value: event.providerPplId.trim(),
        operator: "Equal"
      });
    }

    if (event.consumerPplId && event.consumerPplId.trim()) {
      filters.push({
        jsonPath: "consumerPPLId",
        value: event.consumerPplId.trim(),
        operator: "Equal"
      });
    }

    if (event.processStatusLkup) {
      filters.push({
        jsonPath: "processStatus",
        value: event.processStatusLkup,
        operator: "Equal"
      });
    }

    if (event.serviceCode) {
      filters.push({
        jsonPath: "serviceCode",
        value: event.serviceCode,
        operator: "Equal"
      });
    }

    if (event.processCode) {
      filters.push({
        jsonPath: "processCode",
        value: event.processCode,
        operator: "Equal"
      });
    }

    if (event.paymentDate) {
      filters.push({
        jsonPath: "paymentId",
        value: event.paymentDate,
        operator: "Equal"
      });
    }

    const hasRelevantFilter = filters.some(filter =>
      ["providerName", "consumerName", "providerPPLId", "consumerPPLId"].includes(filter.jsonPath)
    );
    
    if (!hasRelevantFilter) {
      this.openWarningMessage();
      return;
    }

    this.appliedFilters = filters;
    this.searchTimesheets(filters);
  }

  handlePendedTimesheet(event: any) {
    const timesheetLineId = event.timesheetLineId;
    console.log("timesheetLineId", timesheetLineId);
    const filters: any = [
      {
        jsonPath: "timesheetId",
        value: timesheetLineId,
        operator: "Equal"
      }
    ];
    const errorListPayload = this.buildRequestPayload(
      'timesheet-processCode', '',
      filters
    );
    this.listService
      .getListData(errorListPayload, 'claims')
      .subscribe((data: any) => {
        this.errorcodeData = data.responsedata;
        this.openPendedDialog();
      });
  }

  handlePendCodes(timesheetLineIds: any[], event: any) {
    const filters: any = [
      {
        jsonPath: "timesheetId",
        values: timesheetLineIds,
        operator: "IN"
      }
    ];
    const errorListPayload = this.buildRequestPayload(
      'pendCodes', '',
      filters
    );
    this.listService
      .getListData(errorListPayload, 'claims')
      .subscribe((data: any) => {
        this.pendCodes = this.sharedDataService.sortByKey(data.responsedata, 'code');
        this.pendCodes.map((pendCode: any) => {
          pendCode.displayName = `${pendCode.code.trim()} - ${pendCode.externalMessage.trim()}`;
        });
        this.processDataForModel(event);
      });
  }

  openPendedDialog() {
    const dialogConfig: DialogConfig = {
      title: `Pended Timesheet`,
      isOkText: 'Ok',
      size: 'x-large',
      position: 'top',
      showClose: true,
      showButtons: false,
    };

    this.pendedDialogId = this.dialogSvc.openDialog(
      this.pendedDialog,
      dialogConfig,
      () => this.handleCancel(),
      () => this.handleCancel()
    );
  }

  onSaveAdjustment(event: any) {
    this.dialogSvc.closeDialog(this.pendedDialogId);
    this.pendedDialogId = null;
    this.loadRecordsAfterUpdate();
  }

  handleCancel() {
    this.showActionPopup = false;
  }

  rowClicked(event: any) {
    if (event.processStatus.indexOf('Pended') >= 0) {
      this.handlePendedTimesheet(event);
    }
  }

  isFilterValid(timesheetFilterValues: any, searchCallbackFilterValues: any) {
    return Object.entries(timesheetFilterValues)
      .filter(([_, value]) => value !== null && value !== "")
      .every(([key, value]) => {
        const mappedKey = this.keyMapping[key] || key;
        const comparisonValue = mappedKey === 'serviceDate' ? this.dateTimeFormatterService.formatDateToString(value as Date) : value;

        return searchCallbackFilterValues.some((filter: any) => filter.jsonPath === mappedKey && filter.value === comparisonValue);
      });
  }

  gridAction(event: any) {
    this.buttonActionEvent = event.button;
    this.selectedCheckboxes = event.selectedCheckBox;
    this.timesheetActionForm.reset();
    this.totalTimesheetsEffected = 0;

    if (!this.isFilterValid(this.timesheetFilterChildComponent.timesheetSearchForm.value, this.appliedFilters)) {
      const errorMessage = `Some filters are newly applied but the search is not performed. Kindly perform search with updated filter or remove the filter.`;
      this.errorAlertService.openModal('error', 'Error', errorMessage);
      return;
    }

    if (["denyAllTimesheet", "overrideAllTimesheets"].includes(event.button.buttonAction)) {
      if (this.appliedFilters) {
        const filterJsonPaths = this.appliedFilters.map((entry: any) => entry.jsonPath);
        const hasBaseFiltersApplied = filterJsonPaths.includes('serviceDuration') && filterJsonPaths.includes('processStatus');
        const hasUserFiltersApplied = filterJsonPaths.includes('consumerName') || filterJsonPaths.includes('consumerPPLId') || filterJsonPaths.includes('providerName') || filterJsonPaths.includes('providerPPLId');
        const optionalFiltersApplied = filterJsonPaths.includes('serviceId') || filterJsonPaths.includes('paymentId') || filterJsonPaths.includes('serviceCode') || filterJsonPaths.includes('processCode');

        if (!hasBaseFiltersApplied) {
          const errorMessage = `Please select the Service Duration and Process Status to continue with this action.`;
          this.errorAlertService.openModal('error', 'Error', errorMessage);
          return;
        }

        if (!hasUserFiltersApplied && !optionalFiltersApplied) {
          const errorMessage = `Please select at least one filter (Consumer, Provider, Service ID, or Payment ID) to continue with this action.`;
          this.errorAlertService.openModal('error', 'Error', errorMessage);
          return;
        }
      }
      this.openConfirmationPopup(event);
    }
    else if (event.button.buttonAction == 'submitForProcessing') {
      this.handleSubmitForProcessing(event);
    }
    else {
      this.handlePendCodes(event.selectedCheckBox.map((e: any) => e.timesheetLineId), event);
    }
  }

  handleSubmitForProcessing(event: any) {
    const totalInvalidProcessSelected = event.selectedCheckBox.filter((e: any) => e.processingStatusLkp != 'PE' && e.processingStatusLkp != 'SB' && e.processingStatusLkp != 'SE');
    if (totalInvalidProcessSelected.length > 0) {
      const errorMessage = 'Please select only Pending or Submitted or System Error timesheets.';
      this.errorAlertService.openModal('error', 'Error', errorMessage);
      return;
    }

    const selectedIds = event.selectedCheckBox.map((item: any) => item.timesheetLineId);
    const payload =
    {
      "programCode": this.programName,
      "timesheetlineDetailIds": selectedIds
    };

    this.timesheetService.updateTimesheetAdjudication(payload).subscribe((data: any) => {
      if (data.status === 200) {
        this.loadRecordsAfterUpdate();
      }
    });
  }

  processDataForModel(event: any) {
    if (event.button.buttonAction.toLowerCase() == "overrideTimesheet".toLowerCase()) {
      this.allowedProcessCodes = this.pendCodes.filter(e => e.allowOverride);
    } else if (event.button.buttonAction.toLowerCase() == "overrideAllTimesheets".toLowerCase()) {
      this.allowedProcessCodes = this.processCodes.filter(e => e.allowOverride);
    }
    else if (event.button.buttonAction.toLowerCase() == "denyAllTimesheet".toLowerCase()) {
      this.allowedProcessCodes = this.processCodes;
    }
    else {
      this.allowedProcessCodes = this.pendCodes;
    }

    this.setupModal(event.button.button_label);
  }

  openConfirmationPopup(event: any) {
    const dialogConfig: DialogConfig = {
      title: 'Confirmation',
      isOkText: 'Confirm',
      size: 'medium',
      position: 'top',
      showClose: true,
      showButtons: true,
    };

    this.dialogSvc.openDialog(
      this.confirmationDialog,
      dialogConfig,
      () => this.processDataForModel(event),
      () => this.handleCancel()
    );
  }

  openWarningMessage() {
    const dialogConfig: DialogConfig = {
      title: 'Error',
      showOkButton: true,
      isOkText: 'Ok',
      size: 'medium',
      position: 'top',
      showButtons: false,
    };

    this.dialogSvc.openDialog(
      this.warningDialog,
      dialogConfig,
      () => this.handleCancel(),
      () => this.handleCancel()
    );
  }

  handleOk() {
    if (this.timesheetActionForm.invalid) {
      this.timesheetActionForm.markAllAsTouched();
      return;
    }

    const payload: any = {};
    let urlEndpoint = '';
    payload.processCode = [];
    const formValues = this.timesheetActionForm.value;
    formValues.selectedProcessCode?.forEach((code: string) => {
      let requiredCode = [];
      if (this.pendCodes && this.pendCodes.length) {
        requiredCode = this.pendCodes.filter(e => e.code == code);
      } else {
        requiredCode = this.processCodes.filter(e => e.code == code);
      }
      if (requiredCode && requiredCode.length) {
        payload.processCode.push({ code: requiredCode[0].processCodeId || requiredCode[0].processCodeDetailId, reasonLkp: formValues.reason, comments: formValues.comments });
      }
    });
    let placeholder = '';
    switch (this.buttonActionEvent.buttonAction) {
      case 'denyTimesheet': {
        urlEndpoint = ENDPOINTS.CLAIMS.POST_DENY_TIMESHEET;
        placeholder = 'denied';
        payload.timesheetLine = this.selectedCheckboxes.map((value: any) => value.timesheetLineId);
        break;
      }
      case 'overrideTimesheet': {
        urlEndpoint = ENDPOINTS.CLAIMS.POST_OVERRIDE_TIMESHEET;
        placeholder = 'overridden';
        payload.timesheetLine = this.selectedCheckboxes.map((value: any) => value.timesheetLineId);
        break;
      }
      case 'denyAllTimesheet': {
        placeholder = 'denied';
        urlEndpoint = ENDPOINTS.CLAIMS.POST_DENY_ALL_TIMESHEET;
        payload.searchParam = this.appliedFilters;
        break;
      }
      case 'overrideAllTimesheets': {
        placeholder = 'overridden';
        urlEndpoint = ENDPOINTS.CLAIMS.POST_OVERRIDE_ALL_TIMESHEET;
        payload.searchParam = this.appliedFilters;
        break;
      }
    }

    this.timesheetService.denyOverrideTimesheet(urlEndpoint, this.programName, payload, placeholder)
      .subscribe((data: any) => {
        this.showActionPopup = false;
        this.loadRecordsAfterUpdate();
      });
  }

  setupModal = (
    label: string,
  ) => {
    this.title = label;
    this.okText = label;
    this.placeholder = `Select ${label.toLowerCase()} reason.`;
    this.showActionPopup = true;
  };
}
